import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { authCookies } from '@/api/cookies';
import { useAppDispatch } from '@/app/hooks';
import { brand } from '@/brand';
import { getNotifications } from './api/getNotifications';
import { setNotifications } from './model/notificationSlice';

// 1:1 с mcms-front. Дополнительно: enabled только если есть HMAC-cookies
// (на нашем стеке /me/notifications защищён, без cookies вернёт 401) и если
// бренд вообще показывает уведомления — иначе запрос уходил бы на каждый
// заход в кабинет ради данных, которые негде отобразить.

export const useNotifications = () => {
  const dispatch = useAppDispatch();

  const { data: notifications } = useQuery({
    queryKey: ['notifications'],
    queryFn: getNotifications,
    enabled: brand.features.notifications && authCookies.hasFullAuth(),
  });

  useEffect(() => {
    if (!notifications) return;
    dispatch(setNotifications(notifications));
  }, [dispatch, notifications]);
};
